module.exports = __webpack_public_path__ + "static/media/AD.f37d608f.png";